module.exports = __webpack_public_path__ + "static/media/24.2713f75e.jpg";